export default __webpack_public_path__ + "static/media/609.4c141342.jpg";